import Vue from 'vue';

const itsuStoryBus = new Vue;

export default itsuStoryBus;
